import React, { useState, useEffect, useRef } from 'react';
import { getSortedProjects } from '../data/projects';

const Projects = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [projects, setProjects] = useState([]);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    setProjects(getSortedProjects());
  }, []);

  


  return (
    <section id="projects" ref={sectionRef} className={`max-w-6xl mx-auto my-12 sm:my-16 px-4 sm:px-6 opacity-0 translate-y-8 transition-all duration-700 w-full ${isVisible ? 'opacity-100 translate-y-0' : ''}`}>
      <div className="mb-8 text-center sm:mb-12">
        <h1 className="mb-2 text-3xl font-bold text-transparent sm:text-4xl bg-gradient-to-r from-primary to-secondary bg-clip-text">Projects</h1>
        <div className="w-16 h-1 mx-auto rounded-full bg-gradient-to-r from-primary to-secondary"></div>
      </div>
      <div className="grid grid-cols-3 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 sm:gap-6">
        {projects.length === 0 ? (
          <div className="p-8 text-center shadow-lg col-span-full bg-white/5 backdrop-blur-sm rounded-2xl">
            <p className="text-lg text-gray-600">プロジェクトは準備中です...</p>
          </div>
        ) : (
          projects.map((project, index) => {
            return (
              <div
                key={project.id}
                className="flex flex-col h-full overflow-hidden transition-all duration-300 bg-white shadow-lg rounded-2xl hover:shadow-2xl hover:-translate-y-3"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="relative flex-shrink-0 hidden overflow-hidden h-36 sm:block">
                  <img src={project.image} alt={project.title} className="object-cover w-full h-full transition-transform duration-500 hover:scale-110" loading="lazy" />
                  <div className="absolute inset-0 flex items-center justify-center transition-opacity duration-300 opacity-0 bg-gradient-to-br from-primary/90 to-secondary/90 hover:opacity-100">
                    {project.demoUrl && project.demoUrl !== '#' ? (
                      <a href={project.demoUrl} target="_blank" rel="noopener noreferrer" className="px-8 py-4 text-lg font-semibold text-white transition-all duration-300 border-2 border-white bg-white/20 rounded-xl backdrop-blur-sm hover:bg-white hover:text-primary hover:scale-105">
                        View
                      </a>
                    ) : (
                      <span className="px-8 py-4 text-lg font-semibold text-white/80 bg-black/30 rounded-xl backdrop-blur-sm">
                        Coming Soon
                      </span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col flex-1 p-2 sm:p-4">
                  <div className="flex items-start justify-between gap-2 mb-3">
                    <h3 className="flex-1 text-base font-bold text-gray-900 sm:text-lg">{project.title}</h3>
                  </div>
                 <p className="hidden mb-4 text-xs leading-relaxed text-gray-600 sm:block">{project.description}</p>
                  <div className="mb-2 sm:mb-4">
                    <h4 className="mb-1 text-xs font-semibold tracking-wide text-gray-900 uppercase sm:text-sm sm:mb-2">使用技術:</h4>
                    <div className="flex flex-wrap gap-1 sm:gap-2">
                      {project.technologies.map((tech, idx) => (
                        <span key={idx} className="flex items-center gap-1 px-1.5 sm:px-2 py-0.5 sm:py-1 bg-primary/10 rounded-lg text-xs font-medium text-gray-700 hover:bg-primary/20 transition-colors duration-200" title={tech.name}>
                          <span className="text-xs sm:text-sm">{tech.name}</span>
                        </span>
                      ))}
                    </div>
                  </div>

                  {project.features && project.features.length > 0 && (
                    <div className="hidden mb-4 sm:block">
                      <h4 className="mb-2 text-sm font-semibold tracking-wide text-gray-900 uppercase">主な機能:</h4>
                      <ul className="space-y-1">
                        {project.features.slice(0, 3).map((feature, idx) => (
                          <li key={idx} className="flex items-start gap-2 text-sm text-gray-600">
                            <span className="text-primary font-bold mt-0.5">✓</span>
                            <span>{feature}</span>
                          </li>
                        ))}
                        {project.features.length > 3 && (
                          <li className="text-sm text-gray-500">...他 {project.features.length - 3} 機能</li>
                        )}
                      </ul>
                    </div>
                  )}

                  <div className="flex flex-col gap-3 pt-4 mt-auto">
                    {project.demoUrl && project.demoUrl !== '#' && (
                      <a href={project.demoUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center flex-1 gap-2 px-4 py-2 text-sm font-semibold text-white transition-all duration-300 rounded-lg bg-primary hover:bg-primary-dark hover:-translate-y-1 hover:shadow-lg">
                        View
                      </a>
                    )}
                    {project.githubUrl && (
                      <a href={project.githubUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center flex-1 gap-2 px-4 py-2 text-sm font-semibold text-white transition-all duration-300 bg-gray-800 rounded-lg hover:bg-gray-900 hover:-translate-y-1 hover:shadow-lg">
                        GitHub
                      </a>
                    )}
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    </section>
  );
};

export default Projects;
